<template>
    <div class="wrapper">
        <m-header></m-header>
        <div class="wrapper_con">
            <side-bar></side-bar>
            <page-main></page-main>
        </div>
        
        <el-dialog
            :visible.sync="passwordDialogVisible"
            width="500px"
            center
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false">
            <div class="password-expired-content">
                <div class="warning-icon">⚠️</div>
                <h3>密码已过期</h3>
                <p>您的密码已超过90天有效期，请立即修改密码，否则将无法继续使用系统。</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="goToChangePassword">前往修改密码</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import MHeader from './header/index';
    import SideBar from './sideBar/index';
    import PageMain from './PageMain/index'

    export default {
        components: {
            MHeader,
            SideBar,
            PageMain
        },
        computed: {
            passwordExpired() {
                return this.$store.getters.passwordExpired
            }
        },
        data() {
            return {
                passwordDialogVisible: false
            }
        },
        watch: {
            passwordExpired(val) {
                if (val) {
                    this.passwordDialogVisible = true
                }
            }
        },
        mounted() {
            if (this.passwordExpired) {
                this.passwordDialogVisible = true
            }
        },
        methods: {
            goToChangePassword() {
                this.$router.push({ path: '/changePassword' })
                this.passwordDialogVisible = false
            }
        }
    }
</script>

<style scoped>
    .password-expired-content {
        text-align: center;
        padding: 20px 0;
    }
    .password-expired-content .warning-icon {
        font-size: 60px;
        margin-bottom: 15px;
    }
    .password-expired-content h3 {
        color: #E6A23C;
        font-size: 20px;
        margin: 10px 0 20px;
    }
    .password-expired-content p {
        color: #666;
        font-size: 14px;
        line-height: 1.8;
    }
</style>

<style>
    .wrapper {
        width: 100%;
        height: 100%;
        position: relative;
        background-color: #FAFCFF;
    }

    .wrapper_con {
        height: calc(100% - 120px);
        width: 100%;
        padding-top: 60px;
    }

    .sideBar {
        width: 260px;
        height: calc(100% - 60px);
        background-color: #fff;
        position: fixed;
        bottom: 0;
        left: 0;
        overflow: hidden;
        -webkit-transition: width 0.3s;
        transition: width 0.3s;
        z-index: 999;
    }

    /* header */
    .header {
        height: 60px;
        position: fixed;
        top: 0;
        width: 100%;
        left: 0;
        z-index: 999;
    }

    .header_l {
        width: 260px;
        height: 100%;
        float: left;
        background-color: #fff;
        box-sizing: border-box;
        border-bottom: 1px solid #eee;
        border-right: 1px solid #eee;
        transition: width 0.3s;
        overflow: hidden;
        text-align: center;
    }

    .header_r {
        height: 100%;
        margin-left: 260px;
        background-color: white;
        transition: all 0.3s;
    }

    .logoLink {
        color: white !important;
        font-size: 15px;
        display: inline-block;
        font-weight: bold;
        height: 100%;
        line-height: 58px;
    }

    .logoLink img {
        vertical-align: middle;
        position: relative;
    }

    .headr_d1 {
        height: 100%;
        margin-left: 20px;
        padding-right: 20px;
    }

    .headr_d1 .sidecoll {
        float: left;
        margin-top: 20px;
    }

    .headr_d1 .bread {
        float: left;
        margin: 22px 0 0 20px;
    }

    .headr_d1 .el-breadcrumb {
        font-size: 15px;
    }

    .header-title {
        color: #000;
        font-size: 20px;
        line-height: 60px;
        float: left;
    }

    .user-info {
        float: right;
    }

    .pageMain {
        margin-left: 260px;
        transition: all 0.3s;
        height: 100%;
        min-height: 600px;
    }

    .pageMain > div {
        padding: 17px 30px;
        background: #FAFCFF;
    }

    .el-scrollbar {
        height: 100%;
    }

    #app .sideBar .el-scrollbar /deep/ .el-scrollbar__wrap {
        overflow-x: hidden;
        height: 100%;
    }
    .pageMain .card-title{
        border-bottom: 1px solid #eee;
        line-height: 60px;
        padding-right: 34px;
    }
    .pageMain .card-title h2 {
        font-size: 18px;
        color: #333;
        line-height: 59px;
        font-weight: bold;
        padding-left: 29px;
    }

    .pageMain .el-card__body {
        padding: 0;
    }

    .table-box .el-table--striped .el-table__body tr.el-table__row--striped td {
        background: #E5EFFF;
    }

    .table-box .el-table thead th, .table-box .el-table thead tr {
        background: #E5EFFF;
        font-size: 15px;
        color: #333;
    }

    footer {
        height: 60px;
    }

    footer p {
        font-size: 15px;
        text-align: center;
        font-weight: bold;
        line-height: 60px;
    }
    .card-title span{
        margin-left: 5px;
    }
    .line{
        width: 4px;
        height: 18px;
        background: #409EFF;
        display: inline-block;
        position: relative;
        left: 0;
        top: 3px;
    }
    .form-item {
        margin-right: 20px;
    }

    .select-form /deep/ .el-input__inner{
        width: 180px;
    }
    .select-form-search /deep/ .el-input__inner{
        width: 180px;
    }
    .operate-nav {
        margin: 18px 30px;
    }
    .operate-nav .el-form-item{
        margin-bottom: 0;
    }
    .el-button.addBtn{
        background: #409EFF !important;
        border-color: #409EFF !important;
    }
    .el-button.editBtn{
        background: #01BB9A;
        border-color: #01BB9A;
    }
    .el-button.deleteBtn{
        background: #F17121;
        border-color: #F17121;
    }
    .el-button.stateBtn{
        background: #D07F00;
        border-color: #D07F00;
    }
    .pdf-dialog .el-dialog__body {
        height: 100%;
    }
    .text-r{
        text-align: right;
    }

    .model-box{
        border: 1px solid #DDE0E7;
        margin: 19px 30px;
    }
    .model-header{
        height: 40px;
        line-height: 40px;
        padding: 0 24px;
        border-bottom: 1px #DDE0E7 dashed;
    }
    .model-header p{
        font-size: 14px;
        color: #999;
    }
    .model-header p span{
        color: #333;
    }
    .model-header p span.down-span{
        font-size: 14px;
        color: #FD0002;
        cursor: pointer;
        margin-left: 40px;
        text-decoration: underline;
    }
    .model-header p span img{
        position: relative;
        top: 2px;
        margin-right: 5px;
    }
    .model-foot{
        padding: 20px 24px;
    }
    .model-foot .el-button{
        position: relative;
        margin-right: 18px;
    }
    .model-foot .el-button span{
       margin-left: 15px;
    }
    .model-foot .el-button img{
        position: absolute;
        top: 12px;
        left: 18px;
    }
    .model-foot .el-button.down-box span{
        margin-left: 0;
    }
</style>



// WEBPACK FOOTER //
// src/layout/index.vue